import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {ModalConstant} from "@/util/constant/ModalConstant.ts";

export type BaseState = {
    loading: boolean;
    baseLoading: boolean;
    modalOptions: {
        show: boolean,
        component?: ModalConstant,
        metadata?: {
            confirmationOptions?: {
                title?: string,
                message?: string,
                type?: "success" | "warning" | "error" | "delete",
                button?: { title?: string, action: () => void }
            }
            notificationOptions?: {
                title?: string,
                message?: string,
                type?: "success" | "warning" | "error",
                buttons?: { title?: string, action: () => void }[]
            }
        },
        payload?: any,
    }
}

const initialState: BaseState = {
    loading: false,
    baseLoading: false,
    modalOptions: {show: false, metadata: {notificationOptions: {type: "success"}}},
};

const actions = {};
const slice = createSlice({
    name: "base",
    initialState,
    reducers: {
        setLoading: (state, action) => {
            state.loading = action.payload;
        },
        setBaseLoading: (state, action) => {
            state.baseLoading = action.payload;
        },
        setModalOptions(state, action: PayloadAction<BaseState['modalOptions']>) {
            state.modalOptions = action.payload
        },
        resetModalOptions: (state) => ({...state, modalOptions: initialState.modalOptions})
    },
    extraReducers: (builder) => {
        builder
    },
});

export const base = {
    reducer: slice.reducer,
    actions: actions,
    mutation: slice.actions,
};